import { useEngine } from "./hooks/useEngine";
import { Hero } from "./components/Hero";
import { Workbench } from "./components/Workbench";
import { ResultPanel } from "./components/ResultPanel";
import { LocalDataControls } from "./components/LocalDataControls";
import { HowItWorks } from "./components/HowItWorks";
import { CaseStudy } from "./components/CaseStudy";

export function App() {
  const engine = useEngine();

  return (
    <>
      <a className="skip-link" href="#main-content">
        Saltar al contenido principal
      </a>
      <div className="app-shell">
        <Hero onRunHappyPath={engine.run} />
        <main id="main-content">
          <Workbench
            scenarioId={engine.scenarioId}
            inputText={engine.inputText}
            inputState={engine.inputState}
            inputErrors={engine.inputErrors}
            runState={engine.runState}
            uploadError={engine.uploadError}
            onSelectScenario={engine.selectScenario}
            onEditInput={engine.editInput}
            onLoadFile={(file) => void engine.loadFile(file)}
            onRun={engine.run}
            onCancel={engine.cancel}
          />
          <ResultPanel runState={engine.runState} engineResult={engine.engineResult} onChangeRule={engine.applyRuleOverride} />
          {engine.engineResult ? (
            <LocalDataControls canSave={engine.fieldProfiles.length > 0} onSave={engine.saveCurrentRules} />
          ) : null}
          <HowItWorks />
          <CaseStudy />
        </main>
        <footer className="site-footer">
          <p>
            Data Anonymizer — sin cuentas, sin backend propio, sin datos reales por defecto. No certifica
            anonimización real. Código y decisiones en el repositorio público.
          </p>
        </footer>
      </div>
    </>
  );
}
